// extracted by mini-css-extract-plugin
module.exports = {"checkIcon":"SignUpCompletedModal_checkIcon__2I3so","h4":"SignUpCompletedModal_h4__2LBER"};